import { RegionShared } from "@1games-ru/region-shared";
import { TalkRequest, TalkResponse } from "@1games-ru/region-shared/dist/backend/requests/ped";
import { ShowDialogueRequest } from "@1games-ru/region-shared/dist/cef/requests/ped";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import rpc from "@1games-ru/rage-rpc";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import { ConversationResponse } from "@/domains/dialogue/constants/type";

export default function useShowDialogue() {
  const { t } = useTranslation("ped");
  const [dialogue, setDialogue] = useState<ConversationResponse | null>(null);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Ped.ShowDialogue,
      ({ data }: RpcMpProviderSuccessResponse<ShowDialogueRequest>) => {
        setDialogue(data);
        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Ped.ShowDialogue);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Ped.HideDialogue, () => {
      setDialogue(null);
      return true;
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Ped.HideDialogue);
    };
  }, []);

  const handleSelectOption = useCallback(
    async (optionId: number) => {
      if (!dialogue || !dialogue.dialog) return setDialogue(null);

      try {
        const response: RpcMpProviderSuccessResponse<TalkResponse> = await rpc.callServer(
          RegionShared.Backend.Events.Ped.Talk,
          {
            optionId,
          } as TalkRequest,
        );

        if (!response || !response.data.dialog) {
          setDialogue(null);

          await GameMpProvider.closeCurrentInterface();
        } else {
          setDialogue(response.data);
        }
      } catch (e) {
        console.error(e);

        // todo показ ошибки
        // setDialogue(null);
      }

      return true;
    },
    [dialogue],
  );

  const options = useMemo(() => {
    if (!dialogue) return [];

    return dialogue.dialog.options.map((option) => ({
      id: option.id,
      // title: t(`ped.dialogs.${dialogue.dialog.localizationKey}.${option.localizationKey}.title`),
      text: t(`ped.dialogs.${dialogue.dialog.localizationKey}.options.${option.localizationKey}`),
    }));
  }, [dialogue, t]);

  return {
    dialogue,
    isShow: dialogue && dialogue.dialog,
    handleSelectOption,
    options,
  };
}
